import axios from 'axios';

const ENDPOINT = 'directory';

export default {
  delete: async (centro_id, id, business_process) => {
    const url = `${centro_id}/${ENDPOINT}/${id}/?business_process=${business_process}`;
    return await axios.delete(url);
  },

  get: async (centro_id, id) => {
    const url = `${centro_id}/${ENDPOINT}/${id}/`;
    return await axios.get(url);
  },

  list: async (centro_id) => {
    const url = `${centro_id}/${ENDPOINT}`;
    return await axios.get(url);
  },

  post: async (centro_id, data) => {
    const url = `${centro_id}/${ENDPOINT}/`;
    return await axios.post(url, data);
  },

  put: async (centro_id, id, data) => {
    const url = `${centro_id}/${ENDPOINT}/${id}/`;
    return await axios.put(url, data);
  },
};
